module.exports = __webpack_public_path__ + "static/img/qr-code.251a28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion-h5/qr-code.png
// module id = W30d
// module chunks = 2